import { useCallback, useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { getDateFormat } from '../utils';

export const useTimestampLabel = (inputMoment: Moment): string => {
  const { t } = useTranslation();

  const computeLabel = useCallback(
    (inputMoment: Moment): string => {
      const now = moment();

      const diffMinutes = now.diff(inputMoment, 'minutes');
      const diffHours = now.diff(inputMoment, 'hours');

      if (diffMinutes < 1) return t('Now');

      if (diffMinutes < 60) {
        return t('NotificationTimestampMessageMinutes').replace('{0}', String(diffMinutes));
      }

      if (diffHours < 24) {
        return t('NotificationTimestampMessageHours').replace('{0}', String(diffHours));
      }

      if (diffHours < 48) {
        return t('Yesterday');
      }

      return inputMoment.locale(i18next.language).format(getDateFormat());
    },
    [t]
  );

  const [label, setLabel] = useState<string>(() => computeLabel(inputMoment));

  useEffect(() => {
    const update = () => {
      setLabel(computeLabel(inputMoment));
    };

    update();
    const interval = setInterval(update, 60 * 1000);
    return () => clearInterval(interval);
  }, [inputMoment, computeLabel]);

  return label;
};
